import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IAddProjectSchema } from '../types';
import { ProjectRow } from './project-row';
import { useAuthRole } from '@app/utils';

interface Props {
  tableProps: TableProps;
  rows?: IAddProjectSchema[];
  loading: boolean;
  canAddProject: string;
}

const ProjectList = ({ tableProps, rows, loading, canAddProject }: Props) => {
  const { isManager, isSuperAdmin } = useAuthRole();
  const TABLE_HEAD = [
    { id: 'id', label: 'Id', align: 'center' },
    { id: 'projectName', label: 'project Name', align: 'center' },
    { id: 'boardName', label: 'Board Name', align: 'center', sortable: false },
    ...(isSuperAdmin || isManager
      ? [{ id: 'client', label: 'Client', align: 'center', sortable: false }]
      : []),
    { id: 'manager', label: 'Manager', align: 'center', sortable: false },
    { id: 'teamMembers', label: 'Team Members', align: 'center', sortable: false },
    { id: 'startDate', label: 'Start Date', align: 'center' },
    { id: 'estimatedEndDate', label: 'Estimated End Date', align: 'center' },
    { id: 'description', label: 'Description', align: 'center' },
    ...(isSuperAdmin || isManager
      ? [
          { id: 'priority', label: 'Priority', align: 'center' },
          { id: 'updateStatus', label: 'Update Status', align: 'center' },
        ]
      : []),

    { id: 'status', label: 'Status', align: 'center' },
    ...(canAddProject ? [{ id: 'Action', label: 'Action', align: 'center', sortable: false }] : []),
  ];
  return (
    <PaginatedTable<IAddProjectSchema>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <ProjectRow
          row={row}
          canAddProject={canAddProject}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};

export { ProjectList };
